import { addModuleStyles } from '@glu/theming/glu-css-override';

const defaultTheme = ({ legacy, palette }) => (legacy ? undefined : {
  next: true,
  backgroundColor: palette.background,
  infoColor: palette.info,
  errorColor: palette.error,
  closeIcon: 'x-circle',
  iconColor: palette.accent,
  iconSize: 32,
  color: palette.text.dark,
  gutterSpacing: 20,
  borderLeftWidth: 4,
  boxShadow: '1px 1px 10px rgba(0,0,0,0.2)',
  focusColor: palette.focus.normal,
  icons: {
    info: 'info-circle',
    negative: 'exclamation-triangle',
    warning: 'exclamation-circle',
    positive: 'checkmark-circle'
  }
});

const styles = ({ legacyAlert }) => {
  if (!legacyAlert) {
    return {};
  }

  const {
    backgroundColor, infoColor, errorColor, boxShadow,
    iconSize, gutterSpacing, borderLeftWidth, color,
    iconColor, focusColor
  } = legacyAlert;

  return {
    root: {
      '& .alert': {
        boxShadow,
        backgroundColor,
        border: 'none',
        borderLeft: `${borderLeftWidth}px solid ${infoColor}`,
        borderRadius: 0,
        padding: 0,
        display: 'flex',
        alignItems: 'flex-start',

        '&.alert-warning, &.alert-negative': {
          borderLeftColor: errorColor
        },

        '& .Alert-iconGutter': {
          height: iconSize,
          margin: gutterSpacing,
          marginLeft: gutterSpacing - borderLeftWidth,
          marginRight: 0,

          '& .icon-wrapper': {
            height: iconSize,
            width: iconSize,

            '& svg': {
              fill: iconColor,
              height: iconSize,
              width: iconSize
            }
          }
        },
        '& .btn-details': {
          float: 'none',
          margin: 0,
          paddingTop: 0,
          width: '100%',
          textAlign: 'left',
          paddingLeft: 0,
          color,
          '&:focus': {
            outlineColor: focusColor
          },

          '& span svg': {
            fill: color
          }
        },
        '& .Alert-content': {
          marginLeft: gutterSpacing,
          padding: '25px 0 20px',
          flexGrow: 1,

          '& > p': {
            marginBottom: 0
          }
        },
        '& .close': {
          opacity: 1,
          margin: '25px 16px 0',
          right: 0,
          top: 0,
          '&:focus': {
            outlineColor: focusColor
          }
        }
      }
    }
  };
};

addModuleStyles(styles, 'legacyAlert', defaultTheme);
